.toggle {
  display: flex;
  position: relative;
  align-items: center;

  &.checked {
    .switch {
      background-color: var(--primary-600);

      .toggle {
        transform: translateX(1.5rem);

        @media (min-width: 400px) {
          transform: translateX(1.625rem);
        }
      }
    }
  }

  .input {
    opacity: 0;
    position: absolute;
    width: 0.1px;
    height: 0.1px;
    margin: 0;
  }

  .switch {
    position: relative;
    width: 3rem;
    height: 1.5rem;
    border-radius: 10rem;
    cursor: pointer;
    background-color: var(--neutral-200);
    transition-duration: 0.25s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    @media (min-width: 400px) {
      width: 3.375rem;
      height: 1.75rem;
    }

    .toggle {
      position: absolute;
      top: 0.1875rem;
      left: 0.1875rem;
      width: 1.125rem;
      height: 1.125rem;
      border-radius: 10rem;
      background-color: var(--neutral);
      transition-duration: inherit;
      transition-timing-function: inherit;

      @media (min-width: 400px) {
        top: 0.25rem;
        left: 0.25rem;
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }

  .children {
    padding-left: 0.625rem;
    cursor: pointer;
  }

  .skeletons {
    display: flex;
    align-items: center;

    .skeleton {
      &:first-child {
        width: 3rem;
        height: 1.5rem;
        margin-right: 0.5rem;

        @media (min-width: 400px) {
          width: 3.375rem;
          height: 1.75rem;
        }
      }

      &:last-child {
        height: 1.5rem;

        @media (min-width: 400px) {
          height: 1.75rem;
        }
      }
    }
  }
}
